import React from "react";
import { Pressable, View } from "react-native";
import { ErrorBoundary } from "../ErrorBoundary.component";
import { Typography } from "../Typography.component";
import { useBiblo } from "../../hooks/Biblo.hook";
export const ReaderControlsToggle = props => {
  const {
    defaultStyles,
    readerOptions,
    disableDefaultStyles: disableDefaultStylesGlobal
  } = useBiblo();
  const disableDefaultStyles = disableDefaultStylesGlobal || readerOptions.disableDefaultStyles;
  const Element = readerOptions.controlsToggle || View;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the controls button"
  }, /*#__PURE__*/React.createElement(Element, {
    style: disableDefaultStyles ? undefined : {
      marginLeft: defaultStyles.spacing,
      width: 40
    },
    controlsShown: props.controlsShown,
    setControlsShown: props.setControlsShown
  }, /*#__PURE__*/React.createElement(Pressable, {
    style: disableDefaultStyles ? undefined : {
      position: "absolute",
      top: -20,
      right: -defaultStyles.spacing,
      width: 40,
      height: 40,
      alignItems: "center",
      justifyContent: "center"
    },
    onPress: () => props.setControlsShown(prevState => !prevState)
  }, /*#__PURE__*/React.createElement(Typography, null, "\u2699"))));
};
//# sourceMappingURL=ReaderControlsToggle.component.js.map